<template>
  <div
    v-if="!notifications.data || notifications.data.length === 0"
    class="p-4 text-gray-700"
  >
    <p class="text-sm font-semibold">No new notifications</p>
    <p class="text-sm text-gray-600">You're all caught up!</p>
  </div>
  <template v-else>
    <div class="min-h-0 flex-1 overflow-y-auto">
      <NotificationWrapper
        v-for="notification in notifications.data"
        :key="notification.pk"
        :notification="notification"
        @close="emit('close')"
      />
    </div>
    <button
      class="border-t border-gray-100 p-3 text-xs font-medium text-purple-600 hover:bg-gray-50 hover:text-purple-700"
      @click="goToAllNotifications"
    >
      See all notifications
    </button>
  </template>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import NotificationWrapper from "@/components/Core/Notifications/NotificationWrapper.vue";
import { useNotificationsQuery } from "@/services/notifications";

const emit = defineEmits({ close: () => true });

const notifications = useNotificationsQuery();
const router = useRouter();

function goToAllNotifications(): void {
  router.push({ name: "notifications" });
}
</script>
